__turbopack_context__.v({
  "container": "nyX7PW_container",
  "error": "nyX7PW_error",
  "input": "nyX7PW_input",
  "item": "nyX7PW_item",
  "label": "nyX7PW_label",
  "note": "nyX7PW_note",
  "suggestions": "nyX7PW_suggestions",
  "textInput": "nyX7PW_textInput",
  "unit": "nyX7PW_unit",
  "unitContainer": "nyX7PW_unitContainer",
});
